import { render } from "./AddNewWizard.vue?vue&type=template&id=5699caa6&ts=true"
import script from "./AddNewWizard.vue?vue&type=script&lang=ts"
export * from "./AddNewWizard.vue?vue&type=script&lang=ts"

import "./AddNewWizard.vue?vue&type=style&index=0&id=5699caa6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__